/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import ForgotPasswordForm from '../../containers/forgot-password-form';
import Logo from '../../components/logo';
import Footer from '../../components/footer';

const ForgotPasswordWrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100vh;
`;

class ForgotPassword extends React.Component {
    componentDidUpdate(oldProps) {
        if (oldProps.loggedIn !== this.props.loggedIn) {
            this.props.history.push('/');
        }
    }

    render() {
        return (
            <ForgotPasswordWrapper>
                <div>
                    <Logo/>

                    <ForgotPasswordForm/>
                </div>

                <Footer/>
            </ForgotPasswordWrapper>
        );
    }
}

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/pages/forgot-password/index.js